module.exports = __webpack_public_path__ + "img/icon-floating-kakao.9e0f54a8.svg";